import React, { useState, useEffect } from "react";
import { Box, CircularProgress, Button, useMediaQuery } from "@mui/material";
import { ReactComponent as BackIcon } from "../../assets/svg/BackIcon.svg";
import { ReactComponent as RenoWhiteLogo } from "../../assets/svg/RenoWhiteLogo.svg";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Setting } from "../../utils/Setting";
import {
  getApiData,
  getApiDataWith403Handling,
  getAPIProgressData,
} from "../../utils/APIHelper";
import { updateStepMappingToCompleted, initiateContractorOnboardingWorkflow } from "../../utils/stepMappingUtils";
import { useNavigate } from "react-router-dom";
import authActions from "../../redux/reducers/auth/actions";
import _, { isEmpty } from "lodash";
import CompanyInfo from "./components/CompanyInfo";
import LocationInfo from "./components/LocationInfo";
import { useTheme } from "@emotion/react";

const errorObj = {
  cnameErr: false,
  cnameMsg: "",
  locationErr: false,
  locationMsg: "",
  termsAndConditionErr: false,
  termsAndConditionMsg: "",
  expertiseErr: false,
  expertiseMsg: "",
};

const CreateProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { setUserData } = authActions;
  const { userData, token } = useSelector((state) => state.auth);

  const [selectedLocation, setSelectedLocation] = useState({});
  const [btnLoad, setBtnLoad] = useState(false);
  const [step, setStep] = useState(0);
  const [errObj, setErrObj] = useState(errorObj);
  const [userLocation, setUserLocation] = useState("");
  const [expertiseList, setExpertiseList] = useState([]);

  const [state, setState] = useState({
    cname: "",
    businessYear: "",
    employees: "",
    location: "",
    areTermsAccepted: false,
    expertise: "",
  });

  function handleValidation() {
    const error = { ...errObj };
    let isValid = step === 0 ? validateStep0(error) : validateStep1(error);
    setErrObj(error);

    if (isValid) {
      if (step === 0) {
        setStep(1);
      } else {
        addContractorDetailsApiCall();
      }
    }

    function validateStep0(error) {
      let valid = true;
      if (isEmpty(state.cname)) {
        valid = false;
        error.cnameErr = true;
        error.cnameMsg = "Please Enter Company's Name";
      } else if (state.cname.length > 200) {
        valid = false;
        error.cnameErr = true;
        error.cnameMsg =
          "Company Name should not be greater than 200 characters";
      }

      if (isEmpty(state.expertise)) {
        valid = false;
        error.expertiseErr = true;
        error.expertiseMsg = "Please Enter area of expertise";
      }

      if (isEmpty(state.businessYear)) {
        toast.error("Please select the number of business years");
        valid = false;
      }

      if (userData?.role !== "designer" && isEmpty(state.employees)) {
        toast.error("Please select the number of employees");
        valid = false;
      }

      return valid;
    }

    function validateStep1(error) {
      let valid = true;

      // Office location is optional — it can only be set by picking a place
      // from Google, so requiring it would block anyone whose address the
      // service can't resolve.

      if (!state.areTermsAccepted) {
        valid = false;
        error.termsAndConditionErr = true;
        error.termsAndConditionMsg = "Please accept terms & conditions";
      }

      return valid;
    }
  }

  async function addBillingInfoApiCall() {
    try {
      const data = {
        beneficiary_name: "",
        iban: "",
        bank_name: "",
        bank_account: "",
        swift_code: "",
        address: "",
      };

      const response = await getApiData(
        Setting.endpoints.addBillingInfo,
        "POST",
        data
      );

      if (response.success) {
        // toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log("🚀 ~ file: index.js:63 ~ connect api call ~ error:", error);
      toast.error(error.toString());
    }
  }

  useEffect(() => {
    console.log("sate", state);
  }, [state]);

  async function addContractorDetailsApiCall() {
    try {
      setBtnLoad(true);

      const selectedExpertiseIds = expertiseList
        .filter((item) => state.expertise.includes(item.project_name))
        .map((item) => item.id)
        .join(",");

      let data = {
        company_name: state?.cname || "",
        total_years_in_business: state?.businessYear || "",
        company_address: userLocation || "",
        type: userData?.role,
        contractor_expertise: selectedExpertiseIds || "",
        billing_info: [],
      };

      if (userData?.role !== "designer") {
        data.company_size = state?.employees || "";
      }

      console.log("Payload", data);

      const response = await getAPIProgressData(
        Setting.endpoints.addContractorDetails,
        "POST",
        data,
        true
      );

      if (response.success) {
        dispatch(setUserData(response?.data));
        
        try {
          await initiateContractorOnboardingWorkflow(userData?.id, token);
          await updateStepMappingToCompleted(userData?.id, "CREATE_ACCOUNT", token);
          console.log("Contractor onboarding workflow initiated and CREATE_ACCOUNT step completed successfully");
        } catch (error) {
          console.log("Error initiating contractor onboarding workflow:", error);
        }
        
        await addBillingInfoApiCall();
        const hasProjects = await getProjectList();
        if (hasProjects) {
          navigate("/dashboard");
        } else {
          // const hasProposals = await getProposalList();
          // if (hasProposals) {
          //   navigate("/proposals");
          // } else {
          //   navigate("/account-setting");
          // }
          navigate("/account-setting");
        }
      } else {
        // `message` is usually a plain string ("Error converting data type
        // nvarchar to numeric."); reading `.name` off it gave undefined and
        // the toast came up blank. Handle both shapes.
        const apiMessage =
          typeof response?.message === "string"
            ? response.message
            : response?.message?.name ||
              response?.message?.message ||
              "Something went wrong. Please try again.";
        toast.error(apiMessage);
      }
      setBtnLoad(false);
    } catch (error) {
      console.log("🚀 ~ file: index.js:63 ~ loginUser ~ error:", error);
      setBtnLoad(false);
      toast.error(error.toString());
    }
  }

  useEffect(() => {
    if (!isEmpty(userData) && userData?.id) {
      getUserDetailsByIdApiCall();
    }
  }, []);

  async function getUserDetailsByIdApiCall() {
    try {
      const response = await getApiDataWith403Handling(
        Setting.endpoints.me,
        "GET",
        {}
      );
      if (response.success) {
        dispatch(setUserData(response?.data));
        setPreFillDataFunction(response?.data);
      } else {
        setPreFillDataFunction(userData);
      }
    } catch (error) {
      console.log("🚀 ~ file: index.js:63 ~ by id api ~ error:", error);
      setPreFillDataFunction(userData);
    }
  }

  useEffect(() => {
    getProjectList();
  }, []);

  async function getProjectList() {
    try {
      const response = await getApiData(
        `${Setting.endpoints.expertiseList}`,
        "GET",
        {}
      );
      if (response.success) {
        const matched = response.data.filter(
          (item) => item.type === userData.role
        );
        setExpertiseList(matched.length ? matched : response.data);
      }
    } catch (error) {
      console.log("🚀 ~ Error fetching expertise list:", error);
    }
  }

  async function getProposalList() {
    try {
      const response = await getApiData(
        `api/project/list-contractor-project`,
        "GET",
        {},
        {},
        false
      );
      if (!response?.success) {
        return false; // Return false if API call was not successful
      }
      const newDetails = response?.data || [];
      return newDetails.length > 0; // Returns true if proposal exist, false otherwise
    } catch (error) {
      console.error("Something went wrong", error);
      return false;
    }
  }

  const setPreFillDataFunction = (mainData) => {
    if (!isEmpty(mainData?.contractor_data)) {
      const uData = mainData?.contractor_data;
      const obj = {
        lat: uData?.lat || "",
        lng: uData?.long || "",
        location: uData?.company_address || "",
      };
      setSelectedLocation(obj);
      setUserLocation(uData?.company_address || "");

      const newArray =
        uData?.expertise?.map((item) => item?.project_name) || [];

      setState((prev) => ({
        ...prev,
        cname: uData?.company_name || prev.cname,
        businessYear:
          uData?.total_years_in_business?.toString() || prev.businessYear,
        employees: uData?.company_size?.toString() || prev.employees,
        expertise: newArray.length ? newArray : prev.expertise,
        location: uData?.company_address || prev.location,
      }));
    }
  };

  function renderSwitch() {
    switch (step) {
      case 0:
        return (
          <CompanyInfo
            state={state}
            setState={setState}
            errObj={errObj}
            setErrObj={setErrObj}
            expertiseList={expertiseList}
            role={userData?.role}
            isMobile={isMobile}
          />
        );
      case 1:
        return (
          <LocationInfo
            selectedLocation={selectedLocation}
            setSelectedLocation={setSelectedLocation}
            setUserLocation={setUserLocation}
            errObj={errObj}
            setErrObj={setErrObj}
            state={state}
            setState={setState}
            isMobile={isMobile}
          />
        );
    }
  }

  const handleBackClick = () => {
    if (step === 0) {
      navigate("/role");
    } else if (step === 1) {
      setStep(0);
    }
  };

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {!isMobile && (
        <Box
          sx={{
            position: "relative",
            flex: 1.8,
            backgroundImage: `
      linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.12) 32.45%),
      linear-gradient(180deg, rgba(0, 0, 0, 0) 72.71%, rgba(0, 0, 0, 0.6) 86.96%),
      url(/assets/images/${step === 0 ? "bg6.png" : "bg7.png"})
    `,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              bottom: 50,
              left: 70,
            }}
          >
            <RenoWhiteLogo width={170} height="auto" />{" "}
          </Box>
        </Box>
      )}

      <Box
        sx={{
          flex: 2,
          padding: "2vh 4vw",
          display: "flex",
          flexDirection: "column",
          justifyContent: isMobile ? "flex-start" : "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            cursor: "pointer",
            marginBottom: "3vh",
          }}
          onClick={handleBackClick}
        >
          <BackIcon />

          <span
            style={{
              fontFamily: "Inter Tight",
              color: "#0D0D0E",
              fontSize: "18px",
              fontWeight: 500,
            }}
          >
            Back
          </span>
        </Box>
        <div
          style={{
            width: "100%",
            fontSize: isMobile ? "24px" : "40px",
            fontFamily: "Inter Tight",
            textAlign: "left",
            fontWeight: "600",
            color: "#000000",
            letterSpacing: "-0.4px",
            marginBottom: "3vh",
          }}
        >
          Enter your {step === 0 ? "company info" : "office location"}
        </div>

        {renderSwitch()}

        <Button
          variant="contained"
          onClick={handleValidation}
          disabled={btnLoad}
          style={{
            width: "fit-content",
            marginTop: "3vh",
            width: "fit-content",
            backgroundColor: "#4D6BF6",
            borderRadius: "12px",
            fontSize: "16px",
            fontWeight: "600",
            color: "#fff",
            cursor: "pointer",
            border: "1px solid transparent",
            fontFamily: "Inter Tight",
            textAlign: "center",
            boxShadow: "none",
          }}
        >
          {btnLoad ? (
            <CircularProgress size={20} sx={{ color: "#fff" }} />
          ) : step === 0 ? (
            "Continue"
          ) : (
            "Take me to dashboard"
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default CreateProfile;
